<div class="interactive-cases-container">
  <h2>Interactive Cases</h2>
  
  <div *ngIf="loading" class="loading-indicator">
    Loading interactive cases...
  </div>

  <div *ngIf="!loading && cases.length === 0" class="no-cases-message">
    No interactive cases available.
  </div>

  <div *ngIf="!loading && cases.length > 0" class="table-container">
    <table class="interactive-cases-table">
      <thead>
        <tr>
          <th (click)="toggleSort('caseNo')">
            Case No
            <i class="pi" [ngClass]="getSortIcon('caseNo')"></i>
          </th>
          <th (click)="toggleSort('location')">
            Location
            <i class="pi" [ngClass]="getSortIcon('location')"></i>
          </th>
          <th (click)="toggleSort('duration')">
            Duration
            <i class="pi" [ngClass]="getSortIcon('duration')"></i>
          </th>
          <th (click)="toggleSort('specialty')">
            Specialty
            <i class="pi" [ngClass]="getSortIcon('specialty')"></i>
          </th>
          <th (click)="toggleSort('subSpecialty')">
            Sub-Specialty
            <i class="pi" [ngClass]="getSortIcon('subSpecialty')"></i>
          </th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let case of cases; let i= index; let odd = odd" [ngClass]="{'odd': odd}">
          <td>Case - {{ i+1 }}</td>
          <td>{{ case.location }}</td>
          <td>{{ case.duration }}</td>
          <td>{{ case.specialty }}</td>
          <td>{{ case.subSpecialty }}</td>
          <td class="actions-cell">
            <button id="launchInteractiveCase{{ case.id }}" (click)="launchCase(case.id)" class="btn btn-primary">Launch</button>
            <button id="launchExplanation{{ case.id }}" (click)="getExplanation(case.id)" class="btn btn-primary">Explanation</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> 